/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';

import {
  reducer as interfacesTableReducer,
  selectors as tableSelectors,
} from './interfaces/interfacesTableReducer';
import {
  reducer as detailsReducer,
  selectors as detailsSelectors,
} from './interfaces/interfaceDetailsReducer';

export const interfacesReducer = combineReducers({
  table: interfacesTableReducer,
  details: detailsReducer,
});

export const interfacesSelectors = {
  table: tableSelectors,
  details: detailsSelectors,
};

export default interfacesReducer;
